import * as React from 'react';
import InputText from '../controls/InputText';
import FormGroup from '../decorators/FormGroup';
import FormField from '../wrappers/FormField';
import decorateControl from '../wrappers/decorateControl';
import { jsx as _jsx } from "react/jsx-runtime";
const component = decorateControl(InputText, FormGroup);
const InputTextField = props => /*#__PURE__*/_jsx(FormField, {
  ...props,
  component: component
});
export default InputTextField;